/* eslint-disable react/prefer-stateless-function,null,react/no-unused-prop-types */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  selectItemById,
  selectRequestsStateById
} from 'mt-react-common/common/reducers/objectCollection/reducer';
import { t } from 'utils/translates';

import { selectUserId } from 'mt-react-common/modules/users/common/reducers/states/authAccount';
import PopUpLink from 'components/Common/GlobalPopUps/PopUpLink';

const userRoomsCollectionRN = 'messengerModule.collections.userRoomsCollection';

class RoomSidebarBlock extends Component {
  render() {
    if (!this.props.item) {
      return null;
    }
    return (
      <div className="page-sidebar-sticky-wrp">
        <div
          className="panel-group panel-group-side"
          id="panelGroupFilter"
          role="tablist"
          aria-multiselectable="true"
        >
          {this.props.item.members.map(member => (
            <Link
              key={`roomMember-${member.id}`}
              className="list-group-item"
              to={`/users/profile/${member.id}`}
            >
              {member.concatRoles ? (
                <span style={{ float: 'right' }}>
                  <img
                    width={'20px'}
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAR/SURBVGhD7Znfb1NlGMerN0av1PAf6IaJ66KQ1jmnrN3C4rZOEn+i/BBMJhIFo4PIhUFNvECjRPHHlGi8kBE0YCKzXYZZz1aGQDIvECHZghejDWzntD3tCpOe9n18n7PnLKfty2zXnrOS7Jt8kp73vM/3+T7nV7LMsaxlVbHSUt1ehA5vLWFwTXICUnVDpCVnvxZ8sJkOC2QOX8wQ6IWedGi9tGDd+FwoZzB/EFF4g/whKHhQP889adl68WbDucHmBtGGne+Z10XoA5qDG3BPsrde6aDzSE7zCoCeZG+9NKluvyhEedTtJ3vrxW//bnGIxYOeZG+9MlL9JlGIckBPsrdeWtDZKgqhM/IwaKMuyJxunEc75QYttEq834B7kr31uiGtcmbGmiE7/ixkw68AU94ElnoXIPsRAHxyc7L7gM2+DyzxDrCp1yH7z0uQOd8BmTOPAXqSvfVilzbWCgOa0fYBpAnR+Xwi3Q+QvT26euWDTDDYA8ePbofRY1vhyokNAMPPAZxYBxDwFTLQBTD0NMDJFwDObgI4/yr8PboDxsb2QDz2YYaxz+4ga3vk9XpnOeKwJYAeHo/nGtnaJ2xcqQEQsrVPt/QArK+mY/fGRyv2CO3Z3HidHappJ3vrxQ7XXs72rYTPe9pywny9pUbHvGZGdP6LXW2AXqyvdpLsrRcOAIf5l9QUBOnl4ZD8dYObnude9g7AbzcOwfwdrCBMiaAHhmeHVraRvX1ift9FUahSYAHfBbKzX3yAg6JQpcACnd+Qnf2CQFerKFQpsN98XrJbGvErOCwKVgzM3zlENksnNuC7H/ydqijgQvDHL4q1ZLO0Yv1dT/CXMSYKKkIPz2uovDrEBjtq4JdGYeAc+B7mX3cflVWXoNcB8MMKgJ/rAX71APjbOU/y381za3iO76Ht1Sd9gCKg7dUnUVgRtL06JKvqajmmfqrEEhPpI/WzosBmcI8SU8exZioef4hs7JeiJBp46CElngADdSKQEIU2g3vMNdzjd0VV3WRrvSKRyF149TjZnCDE9ZFdwuAInhPVcK8MvysfT06yO6mNNVLXNtybbH98UJHlG0bzl9/ogS07coMl//oR0kebgH1/tw7+xjXznoI67plsX+NXm5ruoXaVVXLN6hUpr+tcqsUN6rdfhozGz2x9TWc+SJHk18V7D4TQe8br/hMvFLWtjPhn4zZuPIANdFobrsqXwyo2Pj44pGMEKRZznTwZjqdaH5k2/Ge8rn7sSe3LV6rFtXk+vNFk/VN/yNE4yw9mRvR45SMrsUzy+c4zBf4trhepfXmCvY7b+QAT+Q30Jju7pYWG+L/HS47GsonuDSMib+yJvSnG4pXyuNeKG8yRXO87LYcjuZ9GYqHHC2uwVuRpMONxl/+3Ar8SB0TmOfB3Iv5d70l5WkmLwprBPerBr0JYI/TKwVX+Pz34y3tKbF5IkodKvL1Nih/76Wz0wsVwdGr6mg7/jWuJt7ZJxQUnvK4QxVi8uJFcYGwXXtcUxVi8+B34V2huA9ibYiyrSuVw/Ae9i/PyCGQFDAAAAABJRU5ErkJggg=="
                    alt={t('Администрация')}
                    title={t('Администрация')}
                  />
                </span>
              ) : null}
              {this.props.item.roomOwnerId === member.id ? (
                <span style={{ float: 'right' }}>
                  <img
                    width={'20px'}
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAIzSURBVGhD7Zg9TgMxEIVNkRiEaCmokLgBJT1CChegTEWVC1BxCCQIFSU3oEBCZFHSwQ2QkPgpaKkQhc3MMrNsHG8S79oWQf6kJ2Xt8b5xeJMCkUgkEok/ieqLfdBrrjPRoeXFAZp+0X2hUXCJZ1peHP7DBTp4CWxenYo9Wl4s1EDuougxDvCNeRk+rcUSNP+Aws+07IxzP76yq+5aBzqTGoWfadkZ5358XEDfi5bK2o/FBfAzrNG2E3Uu0Hj4VCZ73PzvJWSPtp1o1A98c0fqSkh6nAs1FGtq0H6fuACs4R6VzQV6Yw/06A6YXoBGariyQUszgfpjs3kW7lHZTNAz94YeaMkdMO2S8ZvKlndouRI1Wl2HX52PctNl4R7WUHkl6IWedK5Ly+7oW7lZmGfyUw/kIW1ZAdMTrq8S1lC5FfTIvfgM9EBb9YAMPo01kLXPbXOhbuQWfMNf5VqbsAZr6VgB5f18rBa8abs+mMHyS/MXW+YCGrs066qEtXQsh/M+Wdcg/wy8KJ8DU/DyYi5U1tqGppStziasxTM/Z8fybqp+/pnyHJjiuYA/9bVtf5ryM2beTTXNP4NZtBoElJf8M5hFm0lIeck/Ay+0zkFgNc8/M20OgslX/pmYc+A1/0zMOfCafwZeHHMO/OWfiToHvvPPxJiDIPlnYsxBkPwzYBBjDvznn4kyB6Hyz/B/CEKJbMJhM/UpsgmHzdSnyCYcNlOfIptw2Ex9imwSiUQiEQMhvgGkPTlCZCP0eAAAAABJRU5ErkJggg=="
                    alt={t('Владелец группового диалога')}
                    title={t('Владелец группового диалога')}
                  />
                </span>
              ) : null}
              <div className="media media_inline-table">
                <div className="media-left">
                  <img
                    alt=""
                    className="media-object avatar avatar-xxs"
                    src={member.profile.avatarPath}
                  />
                </div>
                <div className="media-body media-middle">
                  <div
                    className="text-overflow text-overflow_sm"
                    title={member.username}
                  >
                    {member.username}
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {this.props.authUserId === this.props.item.roomOwnerId ? (
          <div className="page-sidebar-sticky-wrp">
            <PopUpLink
              hashParams={{ roomUuid: this.props.item.roomUuid }}
              hashName="messengerGroupRoomFormPopUp"
              className="btn btn-primary btn-block m-b-20"
            >
              <i className="fa fa-pencil" /> {t('Редактировать группу')}
            </PopUpLink>
          </div>
        ) : null}
      </div>
    );
  }
}

RoomSidebarBlock.defaultProps = {
  item: null
};

RoomSidebarBlock.propTypes = {
  // CONNECT STATES
  authUserId: PropTypes.number.isRequired,
  item: PropTypes.shape({
    roomUuid: PropTypes.string,
    roomOwnerId: PropTypes.number,
    members: PropTypes.arrayOf(PropTypes.shape({})).isRequired
  }),
  requestState: PropTypes.shape({
    requestInProcess: PropTypes.bool.isRequired
  }).isRequired
};

const mapStateToProps = (state, props) => ({
  authUserId: selectUserId(state),
  requestState: selectRequestsStateById(
    state,
    userRoomsCollectionRN,
    props.match.params.roomUuid
  ),
  item: selectItemById(
    state,
    userRoomsCollectionRN,
    props.match.params.roomUuid
  )
});

export default connect(mapStateToProps)(RoomSidebarBlock);



// WEBPACK FOOTER //
// ./src/components/Messenger/content/RoomViewBlock/RoomSidebarBlock/RoomSidebarBlock.js